import { DefaultFormContext } from 'src/app/controls/forms/default-form-context';
import { IGroup } from 'src/app/models/interfaces/group.interface';
import { FormMode } from '../../controls/common/form-mode';

export class GroupFormContext extends DefaultFormContext<IGroup> {
    /**
     * Instance de groupe affiché dans le formulaire.
     */
    public override item: IGroup;

    // /**
    //  * Indique si le formulaire est visible (true) ou pas (false).
    //  */
    // public formVisible = false;

    public override mode: FormMode = FormMode.Reading;
}
